import Layout from "../layout/Layout";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import * as Navigation from "../../../modules/Navigation";
import { RouteComponentProps } from "@reach/router";
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext";




export default function DashboardPage(props: RouteComponentProps) {

    // Navigate to the first accessible page based on user permissions
    const navigate = useNavigate();
    const { permissions } = usePermissions();

    useEffect(() => {
        const firstAccessibleNav = Navigation.getFirstAccessibleNavigation(permissions);
        if (firstAccessibleNav) {
            // For Inventory, we need to pass an empty string as the entityName parameter
            if (firstAccessibleNav === Navigation.Inventory) {
                Navigation.Inventory.navigate(navigate, "");
            } else {
                // For other navigation items, navigate to their base path
                navigate(firstAccessibleNav.to);
            }
        }
    }, [navigate, permissions]);

    return (
        <Layout pageTitle="Dashboard" showBackButton={false} showBreadcrumb={false} canScroll={false}>
            <h3>Welcome To CellTrak V2!</h3>
        </Layout>
    )
}